module.exports = __webpack_public_path__ + "media/man9.13db3a89.wav";